import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { GoogleAuthProvider } from './utils/googleAuth';
import { useAuth } from './context/AuthContext';
import AdminUsers from './pages/AdminUsers'
import Home from './pages/Home';
import Services from './pages/Services';
import Packages from './pages/Packages';
import Login from './pages/Login';
import Signup from './pages/Signup';
// import AdminPanel from './pages/AdminPanel';
import Dashboard from './pages/Dashboard'
import Orders from './pages/Orders'
import Contact from './pages/Contact';
import About from './pages/About';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import FacebookPackages from './pages/packages/FacebookPackages';
import InstagramPackages from './pages/packages/InstagramPackages';
import TikTokPackages from './pages/packages/TikTokPackages';
import TwitterPackages from './pages/packages/TwitterPackages';
import YouTubePackages from './pages/packages/YouTubePackages';
import './App.css';
import AdminDashboard from './pages/AdminDashboard';
import AdminPackages from './pages/AdminPackages';
import AdminOrders from './pages/AdminOrders';
import Profile from './pages/Profile';
import AdminLayout from "./layout/AdminLayout";
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Create a client
const queryClient = new QueryClient();


function App() {
  const { user, isAuthenticated } = useAuth();
  const isAdmin = user?.role === 'admin';
  const [cartItems, setCartItems] = useState([]);

  const addToCart = (item) => {
    setCartItems(prev => {
      const existing = prev.find(cartItem => cartItem.id === item.id);
      if (existing) {
        return prev.map(cartItem =>
          cartItem.id === item.id
            ? { ...cartItem, quantity: cartItem.quantity + 1 }
            : cartItem
        );
      }
      return [...prev, { ...item, quantity: 1 }];
    });
  };

  const removeFromCart = (itemId) => {
    setCartItems(prev => prev.filter(item => item.id !== itemId));
  };

  const clearCart = () => {
    setCartItems([]);
  };

  return (
    <QueryClientProvider client={queryClient}>
      <GoogleAuthProvider>
        <div className="min-h-screen bg-gradient-to-br from-purple-50 to-white">
          <Navbar 
            isLoggedIn={isAuthenticated} 
            isAdmin={isAdmin} 
            cartItems={cartItems}
            cartCount={cartItems.reduce((sum, item) => sum + item.quantity, 0)}
          />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/packages/facebook" element={<FacebookPackages addToCart={addToCart} />} />
          <Route path="/packages/instagram" element={<InstagramPackages addToCart={addToCart} />} />
          <Route path="/packages/tiktok" element={<TikTokPackages addToCart={addToCart} />} />
          <Route path="/packages/twitter" element={<TwitterPackages addToCart={addToCart} />} />
          <Route path="/packages/youtube" element={<YouTubePackages addToCart={addToCart} />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/profile" element={<Profile />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="packages" element={<AdminPackages />} />
          </Route>
        </Routes>
        <Footer />
      </div>
    </GoogleAuthProvider>
    </QueryClientProvider>
  );
}

export default App;
